import React from "react";

const Location = () => {
  return (
    <div style={{ padding: "16px" }}>
      <p>
        The project is located in a prime location with easy access to markets,
        temples, highways, and universities.
      </p>
      <p>
        The project has a good ambience with four-sided open roads attached to
        it.
      </p>

      <img
        src="/radianceLocation.png"
        alt="radiance map"
        height="100%"
        width="100%"
        style={{ marginTop: "12px" }}
      ></img>
      <img
        src="/radianceLocation2.png"
        alt="radiance map"
        height="100%"
        width="100%"
        style={{ marginTop: "12px" }}
      ></img>
    </div>
  );
};

export default Location;
